import { Button, Modal } from "react-bootstrap";
import axios from "axios";
import { useForm } from "react-hook-form";
import actions from "../../redux/actions/productsActions";
import { useDispatch } from "react-redux";

function EditProduct({ showEdit, setShowEdit, setProduct, product, token }) {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = async (e, data) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const response = await axios({
      method: "PUT",
      url: process.env.REACT_APP_API_URL + `/api/products/${product.id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      data: formData,
    });
    dispatch(actions.editProduct(response.data));
    setShowEdit(false);
  };
  const handleCloseEdit = () => {
    setShowEdit(false);
    setProduct(null);
  };

  return (
    <Modal className="modals" show={showEdit} onHide={handleCloseEdit}>
      <Modal.Header closeButton>
        <Modal.Title>Edit product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {
          <form onSubmit={(e) => handleSubmit(onSubmit(e))} className="mt-3">
            <div className="form-outline mb-3">
              <label className=" form-label" htmlFor="name">
                Name
              </label>
              <input
                placeholder="Name"
                type="text"
                id="name"
                className="form-control"
                {...register("name", { required: true })}
                defaultValue={product.name}
              />
              {errors.name && (
                <span className="text-danger f-roboto">
                  This field is required
                </span>
              )}
            </div>

            <div className="form-outline mb-3">
              <label className=" form-label" htmlFor="description">
                Description
              </label>
              <textarea
                placeholder="Description"
                type="text"
                id="description"
                className="form-control"
                {...register("description", { required: true })}
                defaultValue={product.description}
              />
              {errors.description && (
                <span className="text-danger f-roboto">
                  This field is required
                </span>
              )}
            </div>

            <div className="form-outline mb-3">
              <label className="form-label" htmlFor="image-input">
                Images (2 required)
              </label>
              <input
                id="image-input"
                name="images"
                type="file"
                multiple
                className="form-control"
                accept=".jpg,.png"
                {...register("images", { required: true })}
              />
              {errors.images && (
                <span className="text-danger f-roboto">
                  This field is required
                </span>
              )}
            </div>
            <div className="row mb-3">
              <div className="col">
                <div className="form-outline">
                  <label className=" form-label" htmlFor="price">
                    Price
                  </label>
                  <input
                    placeholder="Price"
                    type="number"
                    id="price"
                    className="form-control"
                    {...register("price", { required: true })}
                    defaultValue={product.price}
                  />
                  {errors.price && (
                    <span className="text-danger f-roboto">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
              <div className="col">
                <div className="form-outline">
                  <label className=" form-label" htmlFor="stock">
                    Stock
                  </label>
                  <input
                    placeholder="Stock"
                    type="number"
                    id="stock"
                    className="form-control"
                    {...register("stock", { required: true })}
                    defaultValue={product.stock}
                  />
                  {errors.stock && (
                    <span className="text-danger f-roboto">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
              <div className="col">
                <div className="form-outline">
                  <label className=" form-label" htmlFor="rating">
                    Rating
                  </label>
                  <input
                    placeholder="Rating"
                    type="number"
                    id="rating"
                    className="form-control"
                    {...register("rating", { required: true })}
                    defaultValue={product.rating}
                  />
                  {errors.rating && (
                    <span className="text-danger f-roboto">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="form-outline mb-3">
              <label className=" form-label" htmlFor="slug">
                Slug
              </label>
              <input
                placeholder="Slug"
                type="text"
                id="slug"
                className="form-control"
                {...register("slug", { required: true })}
                defaultValue={product.slug}
              />
              {errors.slug && (
                <span className="text-danger f-roboto">
                  This field is required
                </span>
              )}
            </div>

            <div className="row mb-3">
              <div className="col">
                <div className="form-outline">
                  <label className="form-label" htmlFor="category">
                    Category
                  </label>
                  <input
                    min="0"
                    placeholder="Category"
                    type="number"
                    id="category"
                    className="form-control"
                    defaultValue={product.categoryId}
                    {...register("category", { required: true })}
                  />
                  {errors.category && (
                    <span className="text-danger f-roboto">
                      This field is required
                    </span>
                  )}
                </div>
              </div>
              <div className="col checkbox-product">
                <div className="form-check border p-2 rounded">
                  <input
                    className="form-check-input mx-1 p-2"
                    type="checkbox"
                    id="sale"
                    defaultChecked={product.sale ? true : false}
                    {...register("sale", { required: false })}
                  />
                  <label className="form-check-label ms-2" htmlFor="sale">
                    On sale
                  </label>
                </div>
              </div>
              <div className="col checkbox-product">
                <div className="form-check border p-2 rounded">
                  <input
                    className="form-check-input mx-1 p-2"
                    type="checkbox"
                    id="highlight"
                    defaultChecked={product.highlight ? true : false}
                    {...register("highlight", { required: false })}
                  />
                  <label className="form-check-label ms-2" htmlFor="highlight">
                    Highlight
                  </label>
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end mt-4">
              <button type="submit" className="btn btn-success btn-block me-2">
                Edit product
              </button>
              <Button variant="outline-secondary" onClick={handleCloseEdit}>
                Close
              </Button>
            </div>
          </form>
        }
      </Modal.Body>
    </Modal>
  );
}

export default EditProduct;
